module.exports = __webpack_public_path__ + "img/crater.fb9bcc18.png";